/**
 * Pre-compiled es messages for RangeCalendar
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  nextMonth: `Mes próximo`,
  nextYear: `Año próximo`,
  previousMonth: `Mes anterior`,
  previousYear: `Año anterior`,
};
